import WebServiceRequest from "../Api/WebServiceRequest";

class TagAddTagToEntity extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag("Tag/AddTagToEntity");
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class TagRemoveTagFromEntity extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag(`Tag/RemoveTagFromEntity`);
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class TagGetAllTags extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag(`Tag/GetAllTags`);
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class TagGetEntitiesByTag extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag(`Tag/GetEntitiesByTag`);
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

class TagGetEntityTypeTagsByObjectId extends WebServiceRequest {
    constructor(context) {
        super(context);
        super.setTag(`Tag/GetEntityTypeTagsByObjectId`);
    }
    setParams(data) {
        super.setRequestParam(data);
    }
}

export {
    TagAddTagToEntity,
    TagRemoveTagFromEntity,
    TagGetAllTags,
    TagGetEntitiesByTag,
    TagGetEntityTypeTagsByObjectId
}